import React from 'react';
import { FooterData, HeadOfficeData } from '../../models/cms';
import { Link } from 'react-router-dom';
import SocialMedia from './SocialMedia';
import rtaLogo from '../../assets/images/rta.svg';
import FooterBlock from './FooterBlock';

interface CustomProps {
  data: FooterData;
  headOfficeData?: HeadOfficeData;
}

export default function FooterWrapper({ data, headOfficeData }: CustomProps) {
  return (
    <footer className="text-white bg-secondary">
      {data?.appPromotion?.item?.length > 0 && (
        <div className="py-12 bg-primary md:py-9">
          <div className="container app-promotion md:flex md:items-center md:justify-center md:space-x-6 lg:space-x-9">
            <h2 className="text-[26px] md:text-[32px] lg:text-[37px] leading-tight font-medium mb-5 md:mb-0">
              {data?.appPromotion?.title}
            </h2>
            <div className="grid grid-cols-2 gap-3.5 lg:gap-4 max-w-[406px] mx-auto md:mx-0">
              {data?.appPromotion?.item.map(
                (store, index) =>
                  store?.url &&
                  !store?.inactive && (
                    <Link
                      to={store?.url}
                      key={index}
                      target={store?.openInNewTab ? '_blank' : '_top'}
                      rel="noopener noreferrer"
                    >
                      <img
                        src={store?.icon?.url}
                        alt={store?.icon?.alternativeText ?? 'Ecodrive'}
                      />
                    </Link>
                  )
              )}
            </div>
          </div>
        </div>
      )}
      <div className="max-w-[1315px] px-5 lg:px-7 xl:px-[50px] mx-auto py-12 font-light md:py-14">
        <div className="grid grid-cols-12 gap-x-4 gap-y-6 md:gap-y-10">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 text-sm md:text-[11px] grid grid-cols-12 gap-x-4 gap-y-9 md:gap-y-7 items-center">
            {data?.logo?.url && (
              <Link
                to={`/`}
                target="_top"
                rel="noopener noreferrer"
                className="col-span-6 md:col-span-12 md:mb-2 ltr:pr-8 rtl:pe-8 md:ltr:pr-0 md:rtl:pe-0"
              >
                <img
                  src={data?.logo?.url ?? ''}
                  alt="Ecodrive"
                  width={192}
                  height={48}
                />
              </Link>
            )}
            {data?.socialLinks && (
              <div className="flex col-span-6 justify-end md:col-span-12 md:order-last md:block">
                <SocialMedia socialMediaData={data?.socialLinks} />
              </div>
            )}
            {headOfficeData && (
              <div className="col-span-12 leading-[1.428]">
                <p className="pb-5 md:pb-3">
                  Address: {headOfficeData?.address}
                </p>
                {headOfficeData?.timing?.map((item, index) => (
                  <p key={`timing-${index}`}>
                    {item?.label}: {item?.value}
                  </p>
                ))}
              </div>
            )}
          </div>
          <div className="grid col-span-12 contact-block md:col-span-6 lg:col-span-4 lg:order-last">
            <div>
              <h3 className="hidden mb-7 text-lg font-light md:block text-tertiary">
                {data?.contactUs?.title}
              </h3>
              <div className="space-y-7 md:space-y-3">
                {data?.contactUs?.contactItem?.map((item, index) => (
                  <div key={`contact-${index}`}>
                    <h6 className="text-sm md:text-[11px] leading-[1.428]">
                      {item?.label}
                    </h6>
                    <p className="text-sm md:text-2xl leading-[1.428]">
                      {item?.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="self-end">
              <img width={118} height={43} src={rtaLogo ?? ''} alt="RTA" />
            </div>
          </div>
          <div className="grid grid-cols-1 col-span-12 gap-4 lg:col-span-5 md:grid-cols-2">
            {data?.menuBlock?.map((item, index) => (
              <div
                key={`block-${index}`}
                className="bg-white rounded-xl md:bg-transparent md:rounded-none"
              >
                <FooterBlock title={item?.title} submenu={item?.navItem} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
